module.exports = __webpack_public_path__ + "img/footer-simbiosis-industrial-verde1.9db80996.jpg";